// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewsLink_root__QIxbn"};